<template>
  <list-table
    :url="url"
    title="لیست درگاه ها بدون تراکنش"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import persianDate from "../../helpers/persianDate";
import TableShowData from "../../components/table";
export default {
  name: "gatewayReportWithoutTransaction",
  data() {
    return {
      url: "accounters-report/gateways-with-not-transaction",
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "user.name",
          label: "نام پذیرنده",
        },
        {
          key: "website",
          label: "آدرس وبسایت",
        },
        {
          key: "mdid12_money_type",
          label: "واحد پولی",
          formatter: (value, key, item) => {
            return value == 483 ? "ریالی" : "دلاری";
          },
        },
        {
          key: "mdid119_status_date",
          label: "تاریخ فعالسازی درگاه",
          formatter: (value, key, item) => {
            return value != null
              ? persianDate.getDate(value) + " , " + persianDate.getTime(value)
              : "-";
          },
        },
      ],
      params: [],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه های ریالی و دلاری بدون تراکنش",
      },
    ]);
  },
};
</script>
